module.exports = __webpack_public_path__ + "static/Floorball-9003ce5a9b74be8d0aeebea72e56d8e1.mp4";